export default __webpack_public_path__ + "static/media/logo.4a4c8521.png";